<div class="gw-space-y-6 gw-p-x-large gw-max-w-lg">
  <form [formGroup]="formGroup" (ngSubmit)="onSubmit()">
    <p class="gw-text-text-primary gw-text-base">
      {{ 'features.settings.parameters.bankingInfo.description' | translate }}
    </p>
    <div class="gw-space-y-4">
      <gatewee-input-v2
        [form]="formGroup"
        controlName="pixKey"
        [label]="
          'features.settings.parameters.bankingInfo.pixKey.label' | translate
        "
        id="banking-info-pixKey"
        type="text"
      ></gatewee-input-v2>
      <gatewee-select-v3
        [items]="pixKeyTypeItems"
        formControlName="pixKeyType"
        [label]="
          'features.settings.parameters.bankingInfo.pixKeyType.label'
            | translate
        "
        inputId="banking-info-pixKeyType"
        [required]="true"
      ></gatewee-select-v3>
      <gatewee-input-v2
        [form]="formGroup"
        controlName="name"
        [label]="
          'features.settings.parameters.bankingInfo.holderName.label'
            | translate
        "
        id="banking-info-name"
        type="text"
      ></gatewee-input-v2>
      <gatewee-input-v2
        [form]="formGroup"
        controlName="document"
        [label]="
          'features.settings.parameters.bankingInfo.document.label' | translate
        "
        id="banking-info-document"
        type="text"
      ></gatewee-input-v2>
    </div>
    <div class="gw-flex gw-justify-end gw-gap-3 gw-mt-6">
      <gatewee-button
        variant="outline"
        [title]="'common.actions.cancel' | translate"
        (clicked)="close()"
        [disabled]="submitting"
      ></gatewee-button>
      <gatewee-button
        variant="primary"
        [title]="'common.actions.save' | translate"
        type="submit"
        [disabled]="submitting || formGroup.invalid"
      ></gatewee-button>
    </div>
  </form>
</div>
